import { Command, CommandHandler } from '@skylab-shared/core';
import { Constructor } from '@skylab-shared/types';

import { CommandBusHandlers } from './command-bus.service';

declare type CommandHandlerDecorator<TCommand extends Command<TParams, TResult>, TParams, TResult> = (target: Constructor<CommandHandler<TCommand, TParams, TResult>>) => void;

export function CommandHandlerFor<TCommand extends Command<TParams, TResult>, TParams, TResult>(command: Constructor<TCommand>): CommandHandlerDecorator<TCommand, TParams, TResult> {
    return target => {
        if (CommandBusHandlers.some(([type]) => type === command)) {
            throw new Error(`Query handler for "${command.constructor.name}" is already registered.`);
        }
        CommandBusHandlers.push([command, target]);
    };
}
